import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const BrewGuide = () => {
  const steps = [
    { icon: FiIcons.FiThermometer, title: "Water", desc: "Use filtered water heated to the specific temperature for your tea type." },
    { icon: FiIcons.FiDroplet, title: "Measure", desc: "Place 2-3 grams of loose leaf tea per 150ml of water into your vessel." },
    { icon: FiIcons.FiClock, title: "Steep", desc: "Allow leaves to unfurl. Pour completely to avoid bitterness, then re-steep." }
  ];

  return (
    <section id="guide" className="py-24 md:py-32 px-6 max-w-6xl mx-auto">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="text-center mb-20"
      >
        <span className="text-jade uppercase tracking-[0.3em] text-[10px] font-bold mb-4 block">Ritual</span>
        <h2 className="text-3xl md:text-5xl font-serif text-plum-dark mb-6">The Art of Brewing</h2>
        <p className="text-gray-600 max-w-2xl mx-auto leading-relaxed">
          Cultivate mindfulness in your daily routine. Proper brewing honors the craftsmanship of the tea artisans and unlocks the full spectrum of flavor.
        </p>
      </motion.div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative">
        {/* Connecting line for desktop */}
        <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-[1px] bg-tea-stone z-0" />

        {steps.map((step, index) => (
          <motion.div 
            key={index}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: index * 0.2 }}
            className="flex flex-col items-center relative z-10"
          >
            <div className="w-24 h-24 rounded-full bg-moon-white border-2 border-jade/20 shadow-sm flex items-center justify-center mb-8 text-jade relative group hover:border-jade transition-colors duration-500">
              <span className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-plum-dark text-moon-white flex items-center justify-center text-xs font-serif shadow-md">
                0{index + 1}
              </span>
              <SafeIcon icon={step.icon} className="w-10 h-10 group-hover:scale-110 transition-transform duration-500" />
            </div>
            <h3 className="font-serif text-2xl text-plum-dark mb-4">{step.title}</h3>
            <p className="text-gray-500 text-sm leading-loose text-center max-w-[250px]">
              {step.desc}
            </p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default BrewGuide;